"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getJwtRemainingTime = exports.isJwtExpired = exports.getJwtExpiration = void 0;
const utils_1 = require("./utils");
/** Returns the token expiry date as a millisecond timestamp */
function getJwtExpiration(jwt) {
    if (!jwt || utils_1.Utils.isEmptyString(jwt) || jwt === "undefined")
        throw new Error("no token given for expiry check");
    const base64Url = jwt.split(".")[1];
    if (!base64Url)
        throw new Error("could not extract token");
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(atob(base64)
        .split("")
        .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(""));
    const { exp } = JSON.parse(jsonPayload);
    return exp * 1000;
}
exports.getJwtExpiration = getJwtExpiration;
function isJwtExpired(jwt) {
    try {
        const exp = getJwtExpiration(jwt);
        const expired = Date.now() >= exp;
        return expired;
    }
    catch (e) {
        // on any error, see jwt as expired
        return true;
    }
}
exports.isJwtExpired = isJwtExpired;
/** returns the remaining time in milliseconds */
function getJwtRemainingTime(jwt) {
    const exp = getJwtExpiration(jwt);
    return exp - Date.now();
}
exports.getJwtRemainingTime = getJwtRemainingTime;
